import { render } from "./PresentationCard.vue?vue&type=template&id=568da2ca"
import script from "./PresentationCard.vue?vue&type=script&lang=js"
export * from "./PresentationCard.vue?vue&type=script&lang=js"

import "./PresentationCard.vue?vue&type=style&index=0&id=568da2ca&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__